import React from "react";
import TimeAgo from "react-timeago";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import { cleanDate } from "../../../../util/app";

const GlucoseMonitoringList = ({ items = [], onView, className, onAddRoute }) => {
    if (items.length < 1)
        return (
            <div className="text-center text-pink">
                <i className="material-icons" style={{ fontSize: "4em" }}>
                    info
                </i>
                <br />
                <strong>No Health glucose monitoring has been added yet</strong>
            </div>
        );
    return (
        <div className={`no-pad table-responsive ${className}`}>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th scope="col" className="text-center">
                            SN
                        </th>
                        <th scope="col">Start Date</th>
                        <th scope="col">End Date</th>
                        <th scope="col">Status</th>
                        <th scope="col">Staff</th>
                        <th scope="col" className="text-center">
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={index}>
                            <td className="text-center">
                                <strong>{index + 1}</strong>
                            </td>
                            <td className="view-message">
                                {cleanDate(item.start, true)}
                                <br />
                                <small className="text-muted">
                                    <TimeAgo date={item.created_at}></TimeAgo>
                                </small>
                            </td>
                            <td className="view-message">
                                {cleanDate(item.end, true)}
                                <br />
                                <small className="text-primary">Routine: {item.routines.length}</small>
                            </td>

                            <td className="view-message">{item.active ? <span className="badge badge-success">Active</span> : <span className="badge badge-danger">Passed</span>}</td>
                            <td className="view-message">
                                <StaffProfileCard item={item.author} />
                            </td>

                            <td className="view-message text-center">
                                {item.active && (
                                    <button onClick={() => onAddRoute(item)} title="Record Routine" className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored mdl-button--primary">
                                        <i className="material-icons text-primary">add</i>
                                    </button>
                                )}
                                <button onClick={() => onView(item)} title="View Detail" className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored mdl-button--primary">
                                    <i className="material-icons text-primary">trending_flat</i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default GlucoseMonitoringList;
